import React from "react";
import styles from "./hero.module.css";
import { NavLink } from "react-router-dom";
import siteHeader from "../../../../../assests/hero-img/siteHeader.png";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

function Hero() {
  const sc1 = () => {
    window.location.href = "https://supplycorner.online/";
  };
  const sc2 = () => {
    window.location.href = "https://solutioncorner.online/";
  };

  const [scrolledbtn, setScrolledbtn] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      setScrolledbtn(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={styles.hero_wrapper}>
      <div className={styles.hero_container}>
        <div className={styles.heroBG}>
          <img
            // src="https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExYnR5MzBmNXZpenFubzJjYzdxMnM1ZTY5bjE0OGRzYnl0dXI3a2hxOCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/1BfRG8cK5SPOer97aK/giphy.gif"
            // src="https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExbDNpaGdwdTdrM2ZjMHh0YTRlcDFybXR5bDNmZzZqdHd3NzdsemRvcyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/3o752oeUYz6S2SHi5W/giphy.gif"
            // src="https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExamk2b2gzcGhhbDZteXl6dWZqMGNjN2VhdGtwZGhuN2RyNXQzc3A4bCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/dZA1Sa7NuUc6KywNGC/giphy.gif"
            src="https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExNHA3cTY2MmZ4ZWVhazc3dTVydWhxeXJ2Zmp6bmNjMjJkdGZjNzRveCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/7b8jdNUoFBdcoILjjv/giphy.gif"
            alt="Particle Animation"
            className={styles.heroGif}
          />
          <div className={styles.bc_Cta}>
            <img
              className={styles.siteHeader}
              src={siteHeader}
              alt="Animation"
            />
            <p className={styles.heroBGSlogan}>Let's grow business together</p>
            <div className={styles.btnSection}>
              <button className={styles.heroBtn} onClick={sc1}>
                SUPPLY CORNER
              </button>
              <button className={styles.heroBtn} onClick={sc2}>
                SOLUTION CORNER
              </button>
            </div>
          </div>
        </div>
        {scrolledbtn && (
          <div
            className={`${styles.btn_container} ${
              scrolledbtn ? styles.active : ""
            }`}>
            <button
              onClick={() =>
                window.scrollTo({ top: 0, behavior: "smooth" })
              }></button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Hero;
